import { queryOptions, useQuery } from "@tanstack/react-query"
import { GET } from "@/api/client"
import type { UsageSummary, Website } from "@/api/types"

export function usageSummaryOptions(website: Website, days: number) {
	return queryOptions({
		queryKey: ["analytics", website, "summary", days],
		queryFn: (): Promise<UsageSummary> =>
			GET("/api/v1/analytics/{website}/summary", {
				params: { path: { website }, query: { days } },
			}),
	})
}

export function useUsageSummary(website: Website, days: number) {
	return useQuery(usageSummaryOptions(website, days))
}
